import api from './api';

const backendUrl = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');

/**
 * Open protected /api/uploads media through the shared short-lived signed-URL
 * endpoint. Direct browser navigation cannot carry the SPA Authorization header.
 */
export async function openSecureMedia(path, windowName = '_blank') {
  if (!path) throw new Error('A media path is required');
  const response = await api.get('/media/sign', { params: { path } });
  const signedPath = response.data?.data?.url;
  if (!signedPath) throw new Error('The media service did not return a URL');
  return window.open(`${backendUrl}${signedPath}`, windowName, 'noopener,noreferrer');
}
